import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractMixedStorageDataStore } from 'v2/data-store/abstract.mixed-storage-data-store';
import {
  MixedStorageStore,
  MixedStorageStoreHash,
  StateData,
} from 'v2/data-store/data-store.types';
import { State } from 'v2/data-store/state';
import { LocalStorageKeys } from 'v2/modules/shared';

export interface IAccountingDashboardViewSettingsState extends StateData {
  fromDate :string;
  endDate :string;
}

@Injectable({ providedIn: 'root' })
export class AccountingDashboardViewSettingsService extends AbstractMixedStorageDataStore<
  IAccountingDashboardViewSettingsState,
  State<IAccountingDashboardViewSettingsState>
> {
  readonly state = new State<IAccountingDashboardViewSettingsState>({
    fromDate: '',
    endDate: '',
  });
  readonly storageKey = LocalStorageKeys.ACCOUNTING_DASHBOARD_VIEW_SETTINGS;
  readonly storeHash :MixedStorageStoreHash<IAccountingDashboardViewSettingsState> =
    {
      '*': MixedStorageStore.LOCAL,
      'lastExportDate': MixedStorageStore.SESSION,
    };

  readonly state$ :Observable<IAccountingDashboardViewSettingsState> = this.state.$;
  readonly fromDate$ = this.state.observe('fromDate');
  readonly endDate$ = this.state.observe('endDate');

  constructor() {
    super();
    this.init();
  }
}
